/** @format */
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, useContext } from 'react';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';
import { MarketContext } from '@toucan/client/global/market';
import { Flag } from '@toucan/client/shared/components/market-flag';

import { MarketSelectorModal } from './components/modal';
import {
    MarketSelectorLink,
    MarketSelectorWrapper,
} from './market-selector.styles';
import { MarketSelectorProps } from './types';

export const MarketSelector: FunctionComponent<MarketSelectorProps> = ({
    'data-testid': dataTestId,
    className,
}: MarketSelectorProps) => {
    const { t } = useTranslation();
    const { setModalContent, setModalVisible, setMenuVisible } =
        useContext(ApplicationContext);
    const { activeMarket } = useContext(MarketContext);

    function openMarketSelectorModal() {
        setMenuVisible(false);
        setModalContent(<MarketSelectorModal />);
        setModalVisible(true, {
            size: ModalSize.SMALL,
        });
    }

    return (
        <MarketSelectorWrapper data-testid={dataTestId} className={className}>
            <Flag marketCode={activeMarket.code} />
            <MarketSelectorLink
                onClick={openMarketSelectorModal}
                data-testid={`${dataTestId}__button`}
            >
                {t('Change location')}
            </MarketSelectorLink>
        </MarketSelectorWrapper>
    );
};
